import { z } from 'zod';
import { OutdoorBarArticleCategoryModelSchema } from 'entities/outdoor-bar-article-category';
import { GetOutdoorBarArticleCategoriesApiResponseSchema } from '../store';

export const createOutdoorBarArticleCategoriesFromGetOutdoorBarArticleCategoriesApiResponse = (
    (response: z.infer< typeof GetOutdoorBarArticleCategoriesApiResponseSchema>) => (
        response.data.map(({
            slug,
            name,

        }) => OutdoorBarArticleCategoryModelSchema.parse({
            uid: slug,
            name,
        }))
    )
);
